import type { ReactNode } from "react";
import { IconRail } from "./IconRail";
import { TopBar } from "./TopBar";

export interface DesktopShellProps {
  children: ReactNode;
  /** Calendar-only: render 60/40 split with aside. */
  hasAside?: boolean;
}

/**
 * Desktop shell:
 *   64px icon-rail (collapsed, never expands) + 56px topbar + PageHero + content
 *   + optional 40% aside (calendar only).
 *
 * Per `DESIGN.md §13`:
 *   - icon-rail sticky left, always collapsed
 *   - PageHero glass-2 + dawn/dusk tint (tint deferred to Phase 2)
 */
export function DesktopShell({ children, hasAside = false }: DesktopShellProps) {
  return (
    <div data-component="DesktopShell" className="relative min-h-[100dvh] flex text-ink-1">
      <IconRail />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        {/* Horizontal gutter is owned by `PageContainer` (per W31 layout
            primitive layer). PageHero still uses `-mx-5` to bleed its
            sticky glass strip back to edge-to-edge. */}
        <main className="flex-1 min-w-0">
          {hasAside ? (
            <div className="grid grid-cols-[60%_40%] gap-0 h-full">
              <div className="min-w-0">{children}</div>
              <aside className="bg-paper-deep border-l border-hairline min-h-[100dvh]">
                {/* aside rendered by the route via Calendar's right-pane */}
              </aside>
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
}
